import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "assets/img/logo.png";
import { ROUTES } from "common/constants/routes";

const Sidebar = ({ className }) => {
  const { pathname } = useLocation();

  const [openedDropdowns, setOpenedDropdowns] = useState([]);

  const handleDropdown = (text) => {
    setOpenedDropdowns((prev) =>
      prev.includes(text) ? prev.filter((p) => p !== text) : [...prev, text]
    );
  };
  return (
    <>
      <aside className={`sidebar ${className}`}>
        <Link to="/" className="logo">
          <img src={logo} alt="JagahDekho" />
        </Link>
        <ul className="menu-list">
          {ROUTES.map(
            ({ onNav, path, children }) =>
              onNav && (
                <li key={onNav?.text}>
                  {children ? (
                    <>
                      <button type="button" onClick={() => handleDropdown(onNav?.text)}>
                        <i className={`${onNav?.icon} me-2`}></i>
                        {onNav?.text}
                      </button>
                      <ul
                        className={`${
                          openedDropdowns.includes(onNav?.text) ? "d-block" : "d-none"
                        }`}
                      >
                        {children.map(
                          (child) =>
                            child?.onNav && (
                              <li key={child?.onNav?.text}>
                                <Link
                                  className={pathname === child?.path ? "active" : ""}
                                  to={child?.path}
                                >
                                  <i className={`${child?.onNav?.icon} me-2`}></i>
                                  {child?.onNav?.text}
                                </Link>
                              </li>
                            )
                        )}
                      </ul>
                    </>
                  ) : (
                    <Link className={pathname === path ? "active" : ""} to={path}>
                      <i className={`${onNav?.icon} me-2`}></i>
                      {onNav?.text}
                    </Link>
                  )}
                </li>
              )
          )}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
